<template>
  <div class="container p-1 my-4 align-items-center">
    <div class="aguarde-container text-center" v-if="loading">
      <div class="spinner-border" role="status"></div>
      <br />
      <span>Aguarde...</span>
    </div>
    <div class="aguarde-container text-center" v-if="(!recorrencia || recorrencia.length == 0) && !loading">
      <h4>Nenhum registro foi encontrado.</h4>
    </div>

    <div class="listarPedidos" v-if="recorrencia">
      <ul class="p-1 list-group">
        <li @click="openDetalhesPagamento(item.id)"
          class="card px-4 py-1 mb-1 shadow btn text-left list-group-item mt-2" v-for="(item, i) in recorrencia"
          :key="i">
          <div class="d-flex justify-content-between flex-lg-row mt-2">
            <span class="col">
              <small>
                <strong>Descrição</strong> <br />
                {{ formatCodigoPagamento(item.codigoReferencia) }}
                <br />
                {{ item.descricaoCurta }}</small>
            </span>
            <span class="col-2">
              <small>
                <strong>Parcelas </strong><br />
                <strong>{{ item.qtParcelasPagas }}/{{
                    item.quantidadeParcelas
                }}</strong>
                <br />
                {{ formatPrice(item.valorTotal / item.quantidadeParcelas) }}
              </small>
            </span>
            <span class="col-2">
              <small>
                <strong>Situação </strong><br />
                <span v-if="item.status == 'QUITADO' || item.status == 'QUITADO_PENDENTE_RENOVACAO'" class="badge badge-success">Quitado
                </span>
                <span v-if="item.status == 'ATRASADO'" class="badge badge-danger">Parcela Atrasada
                </span>
                <span v-if="item.status == 'REGISTRADO'" class="badge badge-warning">Pendente
                </span>
                <span v-if="item.status == 'INICIADO'" class="badge badge-primary">Em Andamento
                </span>

                <br />
                {{ formatDate(item.dataInicio) }}
              </small>
            </span>

            <span class="col-2 m-3 text-right" style="font-size: 32px; color: var(--cor-principal)">&#10097;</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { APIService } from "../../APIService";
const apiService = new APIService();

export default {
  name: "MinhasRecorrencias",
  props: [],
  data() {
    return {
      loading: false,
      recorrencia: null,
    };
  },
  computed: {},
  created() {
    this.obterMinhasRecorrencias();
  },
  methods: {
    obterMinhasRecorrencias() {
      this.loading = true;
      apiService
        .obterMinhasRecorrencias()
        .then((res) => {
          this.recorrencia = res;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    openDetalhesPagamento(id) {
      this.$router.push(`/minhas-parcelas/${id}`);
    },
    formatCodigoPagamento(codigoReferencia) {
      return codigoReferencia == null
        ? ""
        : codigoReferencia.toUpperCase().substring(0, 8);
    },
    formatPrice(value) {
      if (!value) {
        value = 0;
      }
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatDate(date) {
      return this.$moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>

<style  scoped lang="scss">
.color-system-principal {
  color: var(--cor-principal) !important;
}

.color-system-background {
  background-color: var(--cor-principal) !important;
  color: white;
}
</style>